<button
  tuiIconButton
  type="button"
  class="preview-button"
  iconStart="@tui.eye"
  appearance="outline"
  [size]="size"
  (click)="showPreview($event)"
></button>
